import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import type { PageType } from '../Constants/PageType';

// eslint-disable-next-line @typescript-eslint/naming-convention
const isSSR = typeof window === 'undefined';
const storage = isSSR ? undefined : createJSONStorage<PageType | ''>(() => sessionStorage);
export const pageTypeAtom = atomWithStorage<PageType | ''>('pageType', '', storage);
export const previousPageTypeAtom = atomWithStorage<PageType | ''>('previousPageType', '', storage);
